import React from 'react';
import './Modal.scss';
import { Close } from '@material-ui/icons';

const Modal = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        {onClose && (
          <button className="close-button"
            onClick={onClose}>
            <Close />
          </button>
        )}
        {children}
      </div>
    </div>
  );
};

export default Modal;